export default {
  'error.title': 'システムエラーが発生しました',
  'error.description':
    '画面を再読み込みするか、ページを再度開いてください。<br />問題が解決しない場合は、店舗スタッフにお問い合わせください。',
} as Record<string, string>;
